import {Element} from "react-scroll";

const Supporters = () => {
  return (
      <Element name="supporters" className="organizers-section">
        <div className="container">
          <div className="section-header">

            <div className="section-title-header-text">
              <span className="section-subtitle">همراهان ما</span>
              <h2 className="section-title">برگزارکنندگان و حامیان</h2>

            </div>
            <p className="section-description">
              رویداد «برای آب» با همکاری نهادها و سازمان‌های معتبر علمی و صنعتی برگزار می‌شود.
            </p>
          </div>
        </div>
      </Element>
  )
}
export default Supporters